// extracted by mini-css-extract-plugin
export default {"root":"grixF","smallMobile":"ubXQm","mobile":"sjEnf","errorMessage":"SBTfy","inputs":"FpU5q","input":"DV5SV","error":"Ts622","tablet":"RciPr","text":"f2UH4","textLine":"VPynW"};